import get from 'lodash/get'

export const legendPlugin = {
  id: 'legendComponent',
  afterUpdate(chart, _args, options) {
    const legendContainer = document.getElementById(options.containerId)
    legendContainer && options.onUpdate(chart, legendContainer)
  },

  // Update the legend on any mouse event
  afterEvent(chart, args, options) {
    const event = get(args, 'event', null)
    const eventType = get(event, 'type', false)
    const replay = get(args, 'replay', false)

    if ( eventType.includes('mouse') && !replay) {
      // See: https://www.chartjs.org/docs/latest/developers/api.html#getelementsateventformode-e-mode-options-usefinalposition
      const cursorDatapoints = chart.getElementsAtEventForMode(event, 'index', { intersect: false }, true)

      const legendContainer = document.getElementById(options.containerId)
      legendContainer && options.onUpdate(chart, legendContainer, cursorDatapoints)
    }
  }
}
